import {
  Companion_getInstanceha7z78i7nvow as Companion_getInstance,
  ScopeView2pjeasrtqdymw as ScopeView,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ScopeView_project_getInstance());
}
function get__id(_this__u8e3s4) {
  return _this__u8e3s4.prop(ScopeView__id_getInstance());
}
function get_scopeTitle(_this__u8e3s4) {
  return _this__u8e3s4.prop(ScopeView_scopeTitle_getInstance());
}
function get_description(_this__u8e3s4) {
  return _this__u8e3s4.prop(ScopeView_description_getInstance());
}
function get_order(_this__u8e3s4) {
  return _this__u8e3s4.prop(ScopeView_order_getInstance());
}
function prepareScopeViewFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ScopeView__id_getInstance(), ScopeView_project_getInstance(), ScopeView_scopeTitle_getInstance(), ScopeView_description_getInstance(), ScopeView_order_getInstance(), ScopeView_scopeSet_getInstance(), ScopeView_parentView_getInstance(), ScopeView_fromChangeRequest_getInstance(), ScopeView_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ScopeView_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ScopeView_project$_get_name_$ref_ivmiv4() {
  return (p0) => p0.k20();
}
function ScopeView_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_project$_get_serializer_$ref_27edi1() {
  return (p0) => p0.j2j();
}
function ScopeView_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ScopeView_project$_get_annotations_$ref_irfhyt() {
  return (p0) => p0.bz();
}
var ScopeView_projectClass;
function ScopeView_project() {
  if (ScopeView_projectClass === VOID) {
    class $ {
      constructor() {
        ScopeView_project_instance = this;
        var tmp = this;
        tmp.g7z_1 = lazy(ScopeView_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h7z_1 = lazy(ScopeView_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i7z_1 = lazy(ScopeView_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.g7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_project$_get_name_$ref_ivmiv4(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.l7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      t7z(receiver, value) {
        return receiver.u7z(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.t7z(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_project$_get_serializer_$ref_27edi1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_project$_get_annotations_$ref_irfhyt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_project', VOID, VOID, [SerializableProperty()]);
    ScopeView_projectClass = $;
  }
  return ScopeView_projectClass;
}
var ScopeView_project_instance;
function ScopeView_project_getInstance() {
  if (ScopeView_project_instance === VOID)
    new (ScopeView_project())();
  return ScopeView_project_instance;
}
function ScopeView__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ScopeView__id$_get_name_$ref_gdny69() {
  return (p0) => p0.k20();
}
function ScopeView__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView__id$_get_serializer_$ref_x6ge6w() {
  return (p0) => p0.j2j();
}
function ScopeView__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ScopeView__id$_get_annotations_$ref_i0udrg() {
  return (p0) => p0.bz();
}
var ScopeView__idClass;
function ScopeView__id() {
  if (ScopeView__idClass === VOID) {
    class $ {
      constructor() {
        ScopeView__id_instance = this;
        var tmp = this;
        tmp.v7z_1 = lazy(ScopeView__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w7z_1 = lazy(ScopeView__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x7z_1 = lazy(ScopeView__id$annotations$delegate$lambda);
        this.y7z_1 = Companion_getInstance_0().m2p();
        this.z7z_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.v7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView__id$_get_name_$ref_gdny69(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.k7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      t7z(receiver, value) {
        return receiver.u7z(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.t7z(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView__id$_get_serializer_$ref_x6ge6w(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x7z_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView__id$_get_annotations_$ref_i0udrg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView__id', VOID, VOID, [SerializableProperty()]);
    ScopeView__idClass = $;
  }
  return ScopeView__idClass;
}
var ScopeView__id_instance;
function ScopeView__id_getInstance() {
  if (ScopeView__id_instance === VOID)
    new (ScopeView__id())();
  return ScopeView__id_instance;
}
function ScopeView_scopeTitle$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ScopeView_scopeTitle$_get_name_$ref_uw8i2x() {
  return (p0) => p0.k20();
}
function ScopeView_scopeTitle$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_scopeTitle$_get_serializer_$ref_560yu6() {
  return (p0) => p0.j2j();
}
function ScopeView_scopeTitle$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ScopeView_scopeTitle$_get_annotations_$ref_y8ayji() {
  return (p0) => p0.bz();
}
var ScopeView_scopeTitleClass;
function ScopeView_scopeTitle() {
  if (ScopeView_scopeTitleClass === VOID) {
    class $ {
      constructor() {
        ScopeView_scopeTitle_instance = this;
        var tmp = this;
        tmp.a80_1 = lazy(ScopeView_scopeTitle$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b80_1 = lazy(ScopeView_scopeTitle$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c80_1 = lazy(ScopeView_scopeTitle$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.a80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_scopeTitle$_get_name_$ref_uw8i2x(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.m7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      d80(receiver, value) {
        return receiver.e80(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.d80(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_scopeTitle$_get_serializer_$ref_560yu6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_scopeTitle$_get_annotations_$ref_y8ayji(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_scopeTitle', VOID, VOID, [SerializableProperty()]);
    ScopeView_scopeTitleClass = $;
  }
  return ScopeView_scopeTitleClass;
}
var ScopeView_scopeTitle_instance;
function ScopeView_scopeTitle_getInstance() {
  if (ScopeView_scopeTitle_instance === VOID)
    new (ScopeView_scopeTitle())();
  return ScopeView_scopeTitle_instance;
}
function ScopeView_description$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ScopeView_description$_get_name_$ref_jllxkz() {
  return (p0) => p0.k20();
}
function ScopeView_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_description$_get_serializer_$ref_fqxql2() {
  return (p0) => p0.j2j();
}
function ScopeView_description$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ScopeView_description$_get_annotations_$ref_p4fk7m() {
  return (p0) => p0.bz();
}
var ScopeView_descriptionClass;
function ScopeView_description() {
  if (ScopeView_descriptionClass === VOID) {
    class $ {
      constructor() {
        ScopeView_description_instance = this;
        var tmp = this;
        tmp.f80_1 = lazy(ScopeView_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g80_1 = lazy(ScopeView_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h80_1 = lazy(ScopeView_description$annotations$delegate$lambda);
        this.i80_1 = null;
        this.j80_1 = 'null';
      }
      k20() {
        var tmp0 = this.f80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_description$_get_name_$ref_jllxkz(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.n7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      k80(receiver, value) {
        return receiver.e80(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.k80(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_description$_get_serializer_$ref_fqxql2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_description$_get_annotations_$ref_p4fk7m(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_description', VOID, VOID, [SerializableProperty()]);
    ScopeView_descriptionClass = $;
  }
  return ScopeView_descriptionClass;
}
var ScopeView_description_instance;
function ScopeView_description_getInstance() {
  if (ScopeView_description_instance === VOID)
    new (ScopeView_description())();
  return ScopeView_description_instance;
}
function ScopeView_order$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ScopeView_order$_get_name_$ref_8hep7() {
  return (p0) => p0.k20();
}
function ScopeView_order$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_order$_get_serializer_$ref_lwd9do() {
  return (p0) => p0.j2j();
}
function ScopeView_order$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ScopeView_order$_get_annotations_$ref_fc0egw() {
  return (p0) => p0.bz();
}
var ScopeView_orderClass;
function ScopeView_order() {
  if (ScopeView_orderClass === VOID) {
    class $ {
      constructor() {
        ScopeView_order_instance = this;
        var tmp = this;
        tmp.l80_1 = lazy(ScopeView_order$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m80_1 = lazy(ScopeView_order$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n80_1 = lazy(ScopeView_order$annotations$delegate$lambda);
        this.o80_1 = 0.5;
        this.p80_1 = '0.5';
      }
      k20() {
        var tmp0 = this.l80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_order$_get_name_$ref_8hep7(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.o7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      q80(receiver, value) {
        return receiver.u7z(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.q80(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_order$_get_serializer_$ref_lwd9do(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_order$_get_annotations_$ref_fc0egw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_order', VOID, VOID, [SerializableProperty()]);
    ScopeView_orderClass = $;
  }
  return ScopeView_orderClass;
}
var ScopeView_order_instance;
function ScopeView_order_getInstance() {
  if (ScopeView_order_instance === VOID)
    new (ScopeView_order())();
  return ScopeView_order_instance;
}
function ScopeView_scopeSet$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ScopeView_scopeSet$_get_name_$ref_vt2m9t() {
  return (p0) => p0.k20();
}
function ScopeView_scopeSet$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_scopeSet$_get_serializer_$ref_7v265k() {
  return (p0) => p0.j2j();
}
function ScopeView_scopeSet$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ScopeView_scopeSet$_get_annotations_$ref_o9vulo() {
  return (p0) => p0.bz();
}
var ScopeView_scopeSetClass;
function ScopeView_scopeSet() {
  if (ScopeView_scopeSetClass === VOID) {
    class $ {
      constructor() {
        ScopeView_scopeSet_instance = this;
        var tmp = this;
        tmp.r80_1 = lazy(ScopeView_scopeSet$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s80_1 = lazy(ScopeView_scopeSet$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t80_1 = lazy(ScopeView_scopeSet$annotations$delegate$lambda);
        this.u80_1 = false;
        this.v80_1 = 'false';
      }
      k20() {
        var tmp0 = this.r80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_scopeSet$_get_name_$ref_vt2m9t(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.p7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      w80(receiver, value) {
        return receiver.e80(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.w80(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_scopeSet$_get_serializer_$ref_7v265k(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_scopeSet$_get_annotations_$ref_o9vulo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_scopeSet', VOID, VOID, [SerializableProperty()]);
    ScopeView_scopeSetClass = $;
  }
  return ScopeView_scopeSetClass;
}
var ScopeView_scopeSet_instance;
function ScopeView_scopeSet_getInstance() {
  if (ScopeView_scopeSet_instance === VOID)
    new (ScopeView_scopeSet())();
  return ScopeView_scopeSet_instance;
}
function ScopeView_parentView$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ScopeView_parentView$_get_name_$ref_oo3r4u() {
  return (p0) => p0.k20();
}
function ScopeView_parentView$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_parentView$_get_serializer_$ref_amxa4p() {
  return (p0) => p0.j2j();
}
function ScopeView_parentView$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ScopeView_parentView$_get_annotations_$ref_9b7hbh() {
  return (p0) => p0.bz();
}
var ScopeView_parentViewClass;
function ScopeView_parentView() {
  if (ScopeView_parentViewClass === VOID) {
    class $ {
      constructor() {
        ScopeView_parentView_instance = this;
        var tmp = this;
        tmp.x80_1 = lazy(ScopeView_parentView$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y80_1 = lazy(ScopeView_parentView$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z80_1 = lazy(ScopeView_parentView$annotations$delegate$lambda);
        this.a81_1 = null;
        this.b81_1 = 'null';
      }
      k20() {
        var tmp0 = this.x80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_parentView$_get_name_$ref_oo3r4u(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.q7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      c81(receiver, value) {
        return receiver.e80(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.c81(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_parentView$_get_serializer_$ref_amxa4p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z80_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_parentView$_get_annotations_$ref_9b7hbh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_parentView', VOID, VOID, [SerializableProperty()]);
    ScopeView_parentViewClass = $;
  }
  return ScopeView_parentViewClass;
}
var ScopeView_parentView_instance;
function ScopeView_parentView_getInstance() {
  if (ScopeView_parentView_instance === VOID)
    new (ScopeView_parentView())();
  return ScopeView_parentView_instance;
}
function ScopeView_fromChangeRequest$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function ScopeView_fromChangeRequest$_get_name_$ref_p25fc4() {
  return (p0) => p0.k20();
}
function ScopeView_fromChangeRequest$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_fromChangeRequest$_get_serializer_$ref_kpxi2l() {
  return (p0) => p0.j2j();
}
function ScopeView_fromChangeRequest$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function ScopeView_fromChangeRequest$_get_annotations_$ref_d1v02h() {
  return (p0) => p0.bz();
}
var ScopeView_fromChangeRequestClass;
function ScopeView_fromChangeRequest() {
  if (ScopeView_fromChangeRequestClass === VOID) {
    class $ {
      constructor() {
        ScopeView_fromChangeRequest_instance = this;
        var tmp = this;
        tmp.d81_1 = lazy(ScopeView_fromChangeRequest$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e81_1 = lazy(ScopeView_fromChangeRequest$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f81_1 = lazy(ScopeView_fromChangeRequest$annotations$delegate$lambda);
        this.g81_1 = false;
        this.h81_1 = 'false';
      }
      k20() {
        var tmp0 = this.d81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_fromChangeRequest$_get_name_$ref_p25fc4(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.r7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      w80(receiver, value) {
        return receiver.u7z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.w80(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_fromChangeRequest$_get_serializer_$ref_kpxi2l(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_fromChangeRequest$_get_annotations_$ref_d1v02h(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_fromChangeRequest', VOID, VOID, [SerializableProperty()]);
    ScopeView_fromChangeRequestClass = $;
  }
  return ScopeView_fromChangeRequestClass;
}
var ScopeView_fromChangeRequest_instance;
function ScopeView_fromChangeRequest_getInstance() {
  if (ScopeView_fromChangeRequest_instance === VOID)
    new (ScopeView_fromChangeRequest())();
  return ScopeView_fromChangeRequest_instance;
}
function ScopeView_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function ScopeView_readBy$_get_name_$ref_1jfxz4() {
  return (p0) => p0.k20();
}
function ScopeView_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ScopeView_readBy$_get_serializer_$ref_dh8yjr() {
  return (p0) => p0.j2j();
}
function ScopeView_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function ScopeView_readBy$_get_annotations_$ref_7rqho5() {
  return (p0) => p0.bz();
}
var ScopeView_readByClass;
function ScopeView_readBy() {
  if (ScopeView_readByClass === VOID) {
    class $ {
      constructor() {
        ScopeView_readBy_instance = this;
        var tmp = this;
        tmp.i81_1 = lazy(ScopeView_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j81_1 = lazy(ScopeView_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k81_1 = lazy(ScopeView_readBy$annotations$delegate$lambda);
        this.l81_1 = emptySet();
        this.m81_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.i81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ScopeView_readBy$_get_name_$ref_1jfxz4(), null);
        return tmp0.f2();
      }
      j7z(receiver) {
        return receiver.s7z_1;
      }
      m2j(receiver) {
        return this.j7z(receiver instanceof ScopeView() ? receiver : THROW_CCE());
      }
      n81(receiver, value) {
        return receiver.u7z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ScopeView() ? receiver : THROW_CCE();
        return this.n81(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ScopeView_readBy$_get_serializer_$ref_dh8yjr(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ScopeView_readBy$_get_annotations_$ref_7rqho5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ScopeView_readBy', VOID, VOID, [SerializableProperty()]);
    ScopeView_readByClass = $;
  }
  return ScopeView_readByClass;
}
var ScopeView_readBy_instance;
function ScopeView_readBy_getInstance() {
  if (ScopeView_readBy_instance === VOID)
    new (ScopeView_readBy())();
  return ScopeView_readBy_instance;
}
//region block: exports
export {
  get__id as get__id3awjfwg3rsgw9,
  get_description as get_description20dyln4owxipr,
  get_order as get_order35z39a4v9znp3,
  prepareScopeViewFields as prepareScopeViewFields2eqwutoyttf1v,
  get_project as get_project2bky694b9ef47,
  get_scopeTitle as get_scopeTitle3b12utn8vsli8,
};
//endregion

//# sourceMappingURL=ScopeViewFields.mjs.map
